import React from 'react';
import styled from "styled-components";
import MyMap from './components/Map';
import SEO from './components/SEO';

class App extends React.Component {
  render() {
    return <Container>
      <SEO 
        title="Top github contributors"
        desc="" />
      <MyMap width="100%" />
      {/* <SideMenu /> */}
    </Container>
  }
}

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
`

export default App;